const ent = {
  nbsp: '\u{00A0}'
};

export default ent;
